<template>
  <ButtonDropdownOptions data_test="dropdown-general-user">
    <template #custom_trigger>
      <a
        v-tooltip.bottom="$t('navbar.topnavbar.profile')"
        class="profile-avatar flex size-8 cursor-pointer items-center justify-center rounded-full transition-all duration-150 hover:opacity-90"
      >
        <Avatar
          :src="current_profile.attributes.avatar_url"
          :username="current_profile.attributes.name"
          class="shrink-0"
          class_props="bg-primary-100 text-primary-700 font-semibold"
          size="32"
        />
      </a>
    </template>

    <AppLink
      hide_underline
      :to="{ name: profile_route_name }"
    >
      <DropdownOption data-test="profile">
        <FontAwesomeIcon
          :icon="['far', 'user']"
          fixed-width
          size="sm"
        />
        <span>{{ $t('navbar.topnavbar.profile') }}</span>
      </DropdownOption>
    </AppLink>

    <DropdownOption
      v-if="current_is_impersonation"
      @click="stopImpersonation"
    >
      <FontAwesomeIcon
        :icon="['fas', 'person-to-portal']"
        fixed-width
        size="sm"
      />
      <span>Go back to supervisor land</span>
    </DropdownOption>

    <DropdownOption
      data-test="logout"
      @click="handleLogout"
    >
      <FontAwesomeIcon
        :icon="['fas', 'right-from-bracket']"
        fixed-width
        size="sm"
      />
      <span>{{ $t('navbar.topnavbar.logout') }}</span>
    </DropdownOption>
  </ButtonDropdownOptions>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import { ROUTES_CUSTOMERS, ROUTES_EMPLOYEES, ROUTES_PARTNERS } from '@/app/data/route_constants';
import useImpersonation from '@/app/util/impersonation';
import SelectTenantModal from '@/app/shared_components/modals/SelectTenantModal.vue';
import ButtonDropdownOptions from '@/app/shared_components/buttons/ButtonDropdownOptions.vue';
import DropdownOption from '@/app/shared_components/buttons/DropdownOption.vue';

const store = useStore();
const { proxy: app } = getCurrentInstance();
const { stopImpersonation } = useImpersonation();

const current_profile = computed(() => store.getters.current_profile);
const current_profile_true = computed(() => store.getters.current_profile_true);
const current_is_impersonation = computed(() => store.getters.current_is_impersonation);

const has_multiple_profiles = computed(() => {
  if (current_is_impersonation.value && current_profile_true.value.type === PROFILE_TYPES.EMPLOYEE) return false;
  return current_profile_true.value.attributes.profiles_count > 1;
});

const profile_route_name = computed(() => {
  switch (current_profile.value.type) {
    case PROFILE_TYPES.PARTNER:
      return ROUTES_PARTNERS.SETTINGS_PROFILE;
    case PROFILE_TYPES.CUSTOMER:
      return ROUTES_CUSTOMERS.SETTINGS_PROFILE;
    default:
      return ROUTES_EMPLOYEES.SETTINGS_PROFILE;
  }
});

function openSelectTenantModal() {
  app.$buefy.modal.open({ component: SelectTenantModal });
}

function handleLogout() {
  app.emitter.$emit('logout');
}
</script>

<style scoped>
.profile-avatar :deep(img),
.profile-avatar :deep(div) {
  border: 1px solid var(--color-neutral-200);
  border-radius: 9999px;
  box-sizing: border-box;
}
.profile-avatar:hover :deep(img),
.profile-avatar:hover :deep(div) {
  border-color: var(--color-neutral-300);
}
</style>
